import type { AdministrationContentPage } from "@kontextwerk/control-web-frame/components/administration"

export const pageConfig: AdministrationContentPage = {
  id: "email",
  title: "E-Mail-Vorlagen",
  path: "email",
  tabs: [
    ["announcement", "Ankündigung"],
    ["reschedule", "Verschiebung"],
    ["confirmation", "Bestätigung"],
    ["cancellation", "Stornierung"],
    ["follow_up", "Follow-up"],
  ].map(([purpose, title]) => ({
    id: `email-${purpose}`,
    title,
    routeSegment: purpose.replaceAll("_", "-"),
    widthType: "normal",
    testId: `controlAdmin.organizationView.announcementTemplates.email.${purpose}`,
  })),
}
